import React from "react";
import "../../styles/PaymentFilterBar.css";

const PaymentFilterBar = ({
    filters,
    setFilters,
}) => {

    const handleChange = (e) => {

        setFilters({

            ...filters,

            [e.target.name]: e.target.value,

        });

    };

    return (

        <div className="payment-filter-bar">

            <input
                type="text"
                name="search"
                placeholder="Search Payment / Order / Customer..."
                value={filters.search}
                onChange={handleChange}
            />

            <select
                name="status"
                value={filters.status}
                onChange={handleChange}
            >
                <option value="All">All Status</option>
                <option value="Pending">Pending</option>
                <option value="Authorized">Authorized</option>
                <option value="Success">Success</option>
                <option value="Failed">Failed</option>
                <option value="Refunded">Refunded</option>
            </select>

            <select
                name="method"
                value={filters.method}
                onChange={handleChange}
            >
                <option value="All">All Methods</option>
                <option value="UPI">UPI</option>
                <option value="Card">Card</option>
                <option value="Wallet">Wallet</option>
                <option value="Net Banking">Net Banking</option>
                <option value="Cash on Delivery">
                    Cash on Delivery
                </option>
            </select>

            <select
                name="gateway"
                value={filters.gateway}
                onChange={handleChange}
            >
                <option value="All">All Gateways</option>
                <option value="Razorpay">Razorpay</option>
                <option value="PhonePe">PhonePe</option>
                <option value="Stripe">Stripe</option>
                <option value="Cash">Cash</option>
            </select>

        </div>

    );

};

export default PaymentFilterBar;